import { render, staticRenderFns } from "./ReconexionServicios.vue?vue&type=template&id=5f2394fd&"
import script from "./ReconexionServicios.vue?vue&type=script&lang=js&"
export * from "./ReconexionServicios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports